import { ReactNode, useState } from 'react'
import { ChevronDown } from 'lucide-react'
import {
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/components/ui/dropdown-menu'
import { useMediaQuery } from '@/hooks/use-mobile'
import { cn } from '@/lib/utils'

type Props = {
  trigger: ReactNode
  children: ReactNode
}

// Radix sub menus only open to the left or right, which overflows the viewport
// on narrow screens, so on mobile the items expand inline instead.
const ResponsiveDropdownMenuSub = ({ trigger, children }: Props) => {
  const isSmallScreen = useMediaQuery('(max-width: 559px)')
  const [expanded, setExpanded] = useState(false)

  if (!isSmallScreen) {
    return (
      <DropdownMenuSub>
        <DropdownMenuSubTrigger>{trigger}</DropdownMenuSubTrigger>
        <DropdownMenuPortal>
          <DropdownMenuSubContent>{children}</DropdownMenuSubContent>
        </DropdownMenuPortal>
      </DropdownMenuSub>
    )
  }

  return (
    <>
      <DropdownMenuItem
        className={cn('gap-2', expanded && 'bg-accent')}
        onSelect={(event) => {
          event.preventDefault()
          setExpanded((value) => !value)
        }}
      >
        {trigger}
        <ChevronDown
          className={cn(
            'ml-auto h-4 w-4 transition-transform',
            expanded && 'rotate-180',
          )}
        />
      </DropdownMenuItem>
      {expanded ? <div className='ml-3 border-l pl-1'>{children}</div> : null}
    </>
  )
}

export default ResponsiveDropdownMenuSub
